export default __webpack_public_path__ + "static/Bis_Bhola_2-ea61ae368755bf65e062fb8f750a723c.jpg";